import Box from "@storeblocks/box";
import Surface from "@storeblocks/surface";
import styled from "styled-components";

type VariantProps = {
  backgroundVariant: "white" | "transparent";
};

export const TransparentSurface = styled(Surface)<VariantProps>`
  background-color: ${({ backgroundVariant }) => backgroundVariant};
`;

export const TransparentBox = styled(Box)<VariantProps>`
  background-color: ${({ backgroundVariant }) => backgroundVariant};
`;
